import React, { createContext } from 'react';
import { ISearchResultItems } from '../models/search-results';

export interface ISearchResultsContext {
  fetchMoreResults: (searchItem: string) => Promise<void>;
  isMobile: boolean;
  searchItems: ISearchResultItems | [];
  searchPageNumber: number;
  setSearchItems: React.Dispatch<React.SetStateAction<ISearchResultItems | []>>;
  setSearchPageNumber: React.Dispatch<React.SetStateAction<number>>;
  loading?: {
    moreResults: boolean;
    initialResults: boolean;
  };
  setLoading?: React.Dispatch<
    React.SetStateAction<{
      moreResults: boolean;
      initialResults: boolean;
    }>
  >;
}

const defaultState: ISearchResultsContext = {
  fetchMoreResults: async () => Promise.resolve(),
  isMobile: false,
  loading: { moreResults: false, initialResults: false },
  searchItems: [],
  searchPageNumber: 1,
  setLoading: () => null,
  setSearchItems: () => null,
  setSearchPageNumber: () => null,
};

export const SearchResultsContext =
  createContext<ISearchResultsContext>(defaultState);
